import ILoan from './ILoan';
import ILoanDrawdown from './ILoanDrawdown';
import ILoanDrawdownItem from './ILoanDrawdownItem';
import ILoanFee from './ILoanFee';
import ILoanGracePeriod from './ILoanGracePeriod';
import ILoanNote from './ILoanNote';
import ILoanPayoutFigure from './ILoanPayoutFigure';
import ILoanPayoutFigureItem from './ILoanPayoutFigureItem';
import ILoanPayoutFigureSection from './ILoanPayoutFigureSection';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function transformLoan(loan: ILoan): any {
    return {
        dischargeMethod: loan.dischargeMethod,
    };
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function transformLoanFee(fee: ILoanFee): any {
    return {
        amount: fee.amount,
        description: fee.description,
    };
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function transformLoanGracePeriod(loanGracePeriod: ILoanGracePeriod): any {
    return {
        startDate: loanGracePeriod.startDate,
    };
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function transformLoanNote(note: ILoanNote): any {
    return {
        note: note.note,
    };
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function transformLoanPayoutFigure(payoutFigure: ILoanPayoutFigure): any {
    return {
        accruedInterest: payoutFigure.accruedInterest,
        accruedInterestLabel: payoutFigure.accruedInterestLabel,
        accruedInterestMode: payoutFigure.accruedInterestMode,
        approvalStatus: payoutFigure.approvalStatus,
        borrowerName: payoutFigure.borrowerName,
        dischargeDate: payoutFigure.dischargeDate,
        interestAmount: payoutFigure.interestAmount,
        loanCode: payoutFigure.loanCode,
        loanUuid: payoutFigure.loanUuid,
        minimumTermInterest: payoutFigure.minimumTermInterest,
        minimumTermInterestMode: payoutFigure.minimumTermInterestMode,
        prepaidInterest: payoutFigure.prepaidInterest,
        prepaidInterestAuto: payoutFigure.prepaidInterestAuto,
        prepaidInterestMode: payoutFigure.prepaidInterestMode,
        principalAmount: payoutFigure.principalAmount,
        sections: payoutFigure.sections.map(transformLoanPayoutFigureSection),
        trustAmount: payoutFigure.trustAmount,
    };
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function transformLoanPayoutFigureItem(payoutFigureItem: ILoanPayoutFigureItem): any {
    return {
        amount: payoutFigureItem.amount,
        name: payoutFigureItem.name,
        payoutFigureSectionUuid: payoutFigureItem.payoutFigureSectionUuid,
    };
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function transformLoanPayoutFigureSection(payoutFigureSection: ILoanPayoutFigureSection): any {
    return {
        items: payoutFigureSection.items.map(transformLoanPayoutFigureItem),
        name: payoutFigureSection.name,
        payoutFigureUuid: payoutFigureSection.payoutFigureUuid,
        type: payoutFigureSection.type,
    };
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function transformLoanDrawdown(drawdown: ILoanDrawdown): any {
    return {
        approvedDrawdownAmount: drawdown.approvedDrawdownAmount,
        retainedContingencyAmount: drawdown.retainedContingencyAmount,
        retainedFundsAmount: drawdown.retainedFundsAmount,
    };
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function transformLoanDrawdownItem(drawdownItem: ILoanDrawdownItem): any {
    return {
        amount: drawdownItem.amount,
        description: drawdownItem.description,
        sortOrder: drawdownItem.sortOrder,
    };
}

